import React, {useEffect, useState} from "react";
import {Link} from "gatsby";

const CookieConsent: React.FC = () => {

    const [cookieConsentGiven, setCookieConsentGiven] = useState(false);

    useEffect(() => {
        const mtm_cookie_consent = (document.cookie.match(/^(?:.*;)?\s*mtm_cookie_consent\s*=\s*([^;]+)(?:.*)?$/) || [, false])[1];
        setCookieConsentGiven(mtm_cookie_consent);
    });


    const onAcceptCookiesClick = () => {
        if (window._paq) {
            setCookieConsentGiven(true);
            window._paq.push(['rememberCookieConsentGiven']);
            window._paq.push(['setCookieConsentGiven']);
        }
    }

    if (cookieConsentGiven) return (<></>);

    return (
        <div className={'fixed fixed bottom-0 w-full border-red bg-red'}>
            <div className="container">
                <div
                    className={'text-white flex flex-col lg:flex-row items-center lg:gap-4 px-8 md:px-16 lg:px-32'}>
                    <p>Diese Website verwendet Cookies zu Analysezwecken. Weitere Informationen entnehmen Sie
                        unserer <Link
                            className={'underline'}
                            title={'zur Datenschutzerklärung'} to={'/datenschutz'}>Datenschutzerklärung</Link>.</p>
                    <a className={'py-2 px-4 ml-auto mr-auto bg-white text-red font-bold mb-4 lg:mb-0'}
                       onClick={onAcceptCookiesClick} href={'#'}>Akzeptieren</a>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;
